var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGdppercapita(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.42 24.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f363f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.08,395a12.21,12.21,0,1,0,12.21,12.21A12.24,12.24,0,0,0,286.08,395Zm0,23.47a11.25,11.25,0,1,1,11.23-11.26A11.28,11.28,0,0,1,286.08,418.5Z",
    transform: "translate(-273.86 -395.03)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.7,406.32a4.87,4.87,0,0,1-1.81-.94,1.77,1.77,0,0,1-.5-1.3,1.7,1.7,0,0,1,1.91-1.88,1.69,1.69,0,0,1,1.44.71,3,3,0,0,1,.5,1.8h1.61a4.29,4.29,0,0,0-.77-2.64,3,3,0,0,0-2.14-1.17v-1.85h-1.31v1.81a3.33,3.33,0,0,0-2.14,1,3.2,3.2,0,0,0-.77,2.21,3,3,0,0,0,.83,2.25,6,6,0,0,0,2.52,1.34,4.87,4.87,0,0,1,1.74.93,1.8,1.8,0,0,1,.53,1.28,1.72,1.72,0,0,1-.6,1.4,2.44,2.44,0,0,1-1.64.51,2.34,2.34,0,0,1-1.57-.54,2.48,2.48,0,0,1-.57-1.81h-1.58v0a3.29,3.29,0,0,0,.87,2.58,3.7,3.7,0,0,0,2.31,1v1.58h1.31v-1.58a3.58,3.58,0,0,0,2.31-1,3.44,3.44,0,0,0,0-4.46A6.82,6.82,0,0,0,286.7,406.32Z",
    transform: "translate(-273.86 -395.03)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdppercapita);
export default __webpack_public_path__ + "static/media/gdppercapita.5654bc39876630098e498d2e06dfd160.svg";
export { ForwardRef as ReactComponent };